var map = {
	"./action_image.png": 261,
	"./dimond.png": 262,
	"./logo_01.png": 54,
	"./logo_02.png": 92,
	"./logo_03.png": 93,
	"./logo_04.png": 55,
	"./logo_05.png": 56,
	"./p_feature1.png": 263,
	"./prototype_banner_img.png": 264,
	"./prototype_banner_img2.png": 265,
	"./psd.png": 266,
	"./saas.png": 267,
	"./tab.png": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;